export default "__VITE_ASSET__B7bG9AzY__"